import React from 'react';
import { ConfirmEmailLink } from 'ecs-react-components/dist/index.es';
import history from '../../../history';
import * as api from './user-profile-api';
import { loadPatient } from '../patient/patient-middleware';
import { loadCapabilities } from '../capability/capability-middleware';
import * as FacilityActions from '../facility/facility-middleware';
import { userPreferenceSet, userProfileLoadedSuccess, termsOfUseLoadedSuccess }
  from './user-profile-action-creator';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import { getExternalSystems } from '../external-systems/external-systems-middleware';
import { getLocalizedFacilityContent } from '../localization/localization-api';

const loadUserProfileSuccess = (response, inputLoginType, loginCallBack, userInfo) => (dispatch) => {
  // load redux/profile/user
  dispatch(userProfileLoadedSuccess(response.data));
  // load redux/capability
  dispatch(loadCapabilities(response.data.userId));

  // extract patientId from Ids array
  const patient = response.data.ids.find((id) => id.idType === 'Patient');

  if (patient) {
    // load redux/patient
    dispatch(loadPatient(patient.value)).then(
      () => {
        let loginType = 'default';
        if (inputLoginType) {
          loginType = inputLoginType;
        }

        // load redux/facility & redux/language/translations
        dispatch(FacilityActions.loadFacilityByPatientId(patient.value, loginCallBack, userInfo));

        if ([
          'patientkioskmanagement',
          'patientkioskuser',
          'patientlinkuser',
        ].indexOf(loginType.toLowerCase()) < 0) {
          dispatch(getExternalSystems(patient.value));
        }
      }
    );
  }
};

export const loadUserProfile = (loginType, loginCallBack) => (dispatch) =>
  api.getUser().then(
    (response) => {
      const userInfo = response && response.data ? response.data : null;

      dispatch(
        loadUserProfileSuccess(
          response,
          loginType,
          loginCallBack,
          userInfo)
      );
      return userInfo;
    },
    () => {
      dispatch(MsgBarActions.showErrorMessage());
    }
  );

export const setUserPreference = (name, value) => (dispatch, getState) =>
  api.setUserPreference(getState().profile.user.userId, value, name).then(
    (response) => {
      dispatch(userPreferenceSet(response.name, response.value));
    }
  );

export const resendEmailConfirmationEmail = (userId, language) => () =>
  api.resendConfirmationEmail(userId, language);

export const acceptTou = (userId) =>
  (dispatch) =>
    api.acceptTermsOfUse(userId)
      .then(
        (response) => {
          dispatch(userProfileLoadedSuccess(response.data));
          history.push('/');
        },
        (axiosResponse) => {
          const error = axiosResponse.response;
          dispatch(MsgBarActions.showErrorMessage(error.message));
        }
      );

export const confirmEmailRequestByUserId = (dispatch, userId, userEmail, language) =>
  () => dispatch(resendEmailConfirmationEmail(userId, language))
    .then(
      () => dispatch(MsgBarActions.showSuccessMessage('confirmationEmailSent', [userEmail])),
      () => dispatch(MsgBarActions.showErrorMessage('confirmationEmailSendError'))
    );

export const saveProvidedUserEmail = (userId, email, callback) => (dispatch) =>
  api.saveProvidedEmail(userId, email)
    .then(
      (response) => {
        const userInfo = response.data;
        dispatch(userProfileLoadedSuccess(userInfo));
        const link = (<ConfirmEmailLink
          onClickMethod={
            confirmEmailRequestByUserId(dispatch, userInfo.userId, userInfo.email)
          }
        />);
        const parameters = [userInfo.email, link];
        dispatch(MsgBarActions.showStickyWarningMessage('confirmEmailRequired', parameters));
        if (callback) {
          callback();
        }
      },
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadTermsOfUse = (facilityId, languageCode) =>
  (dispatch) =>
    getLocalizedFacilityContent('TermsOfUse', facilityId, languageCode)
      .then(
        (response) => dispatch(termsOfUseLoadedSuccess(response.data)),
        (axiosResponse) => {
          const error = axiosResponse.response;
          dispatch(MsgBarActions.showErrorMessage(error.message));
        }
      );
